module.exports = __webpack_public_path__ + "static/softball1-c8bd2bd608e28c6779cd7ceccde34c7c.jpg";